import classNames from 'classnames';
import React from 'react';
import css from './TextInput.module.scss';

export default React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(function TextInput({ className, ...props }, ref) {
   return <input ref={ref} className={classNames(css.textInput, className)} {...props} />
})
